<div class="content-wrapper pyro">
    <!-- The whole area is the button, in every state. -->
    <div class="before background ready-area" *ngIf="!skipping" longPress (click)="touchReady()"
        [attr.data-ready-state]="readyState" [class.portrait]="theme === AppTheme.THE_PORTRAIT">
        <app-ready-fallback *ngIf="builtinShown" [theme]="theme"></app-ready-fallback>
        <!-- Invisible until fully downloaded: never drawn half-way, top to bottom. -->
        <img *ngIf="readyImageSrc" [src]="readyImageSrc" class="ready-picture" [class.shown]="readyState === 'picture'"
            alt="" (load)="onReadyImageLoad()" (error)="onReadyImageError()" />
        <div class="ready-loading" *ngIf="readyState === 'loading'">
            <span class="ready-spinner"></span>
            <p class="ready-loading-text">Loading…</p>
        </div>
    </div>
</div>


<ng-template #pointCollectModal let-modal>
    <app-point-collect-dialog (onCloseDialog)="handleCloseDialog($event)">
    </app-point-collect-dialog>
</ng-template>

<app-loading *ngIf="commonService.isLoading"></app-loading>
<app-prepare *ngIf="retrying"></app-prepare>